/** HireIQ canonical pipeline (8 stages + terminal Rejected). */
export const HIREIQ_STAGES = [
  'Applied',
  'Assessment',
  'Qualified',
  'Interview',
  'Technical Task',
  'Offer',
  'Hired',
  'Rejected',
];

/** Full set for filters and dropdowns (canonical + legacy ATS labels). */
export const STAGES = {
  APPLIED: 'Applied',
  ASSESSMENT: 'Assessment',
  QUALIFIED: 'Qualified',
  INTERVIEW: 'Interview',
  TECHNICAL_TASK: 'Technical Task',
  OFFER: 'Offer',
  HIRED: 'Hired',
  REJECTED: 'Rejected',
  SCREENING: 'Screening',
  ASSESSMENT_SENT: 'Assessment Sent',
  ASSESSMENTS_PASSED: 'Assessments Passed',
  ASSESSMENTS_FAILED: 'Assessments Failed',
  INTERVIEW_SCHEDULED: 'Interview Scheduled',
  INTERVIEWED: 'Interviewed',
  OFFER_SENT: 'Offer Sent',
  WITHDRAWN: 'Withdrawn',
  ON_HOLD: 'On Hold',
};

export const STAGE_COLORS = {
  Applied: 'bg-blue-100 text-blue-800',
  Assessment: 'bg-cyan-100 text-cyan-800',
  Qualified: 'bg-teal-100 text-teal-800',
  Interview: 'bg-purple-100 text-purple-800',
  'Technical Task': 'bg-orange-100 text-orange-800',
  Offer: 'bg-amber-100 text-amber-800',
  Hired: 'bg-emerald-100 text-emerald-800',
  Rejected: 'bg-red-100 text-red-700',
  Screening: 'bg-indigo-100 text-indigo-800',
  'Assessment Sent': 'bg-yellow-100 text-yellow-800',
  'Assessments Passed': 'bg-green-100 text-green-800',
  'Assessments Failed': 'bg-red-100 text-red-800',
  'Interview Scheduled': 'bg-purple-100 text-purple-800',
  Interviewed: 'bg-violet-100 text-violet-800',
  'Offer Sent': 'bg-amber-100 text-amber-800',
  Withdrawn: 'bg-gray-100 text-gray-700',
  'On Hold': 'bg-orange-100 text-orange-800',
};

export const CLASSIFICATION_COLORS = {
  Strong: 'bg-emerald-100 text-emerald-800',
  Standard: 'bg-blue-100 text-blue-800',
  Risk: 'bg-red-100 text-red-700',
  Unclassified: 'bg-gray-100 text-gray-600',
};

export const ROLES = {
  ADMIN: 'admin',
  HRM: 'hrm',
  INTERVIEWER: 'interviewer',
  VIEWER: 'viewer',
};

export const ROLE_LABELS = {
  admin: 'Admin',
  hrm: 'HR Manager',
  interviewer: 'Interviewer',
  viewer: 'Viewer',
};

export const ROLE_COLORS = {
  admin: 'bg-red-100 text-red-800',
  hrm: 'bg-blue-100 text-blue-800',
  interviewer: 'bg-purple-100 text-purple-800',
  viewer: 'bg-gray-100 text-gray-700',
};

/** Timed MCQ bank + scored assessments (not take-home TechTask assignments). */
export const MCQ_ASSESSMENT_TYPES = ['Personality', 'Top Strengths', 'IQ', 'English'];
export const TEST_TYPES = MCQ_ASSESSMENT_TYPES;
export const ALL_ASSESSMENT_TYPES = [...MCQ_ASSESSMENT_TYPES, 'Technical Task'];

/** HireIQ MCQ bank groupings (maps to test types server-side). */
export const ASSESSMENT_CATEGORIES = ['Personality', 'Soft Skills', 'IQ/Logic', 'English'];

export const NOTICE_UNITS = ['Days', 'Weeks', 'Months'];

export const SOURCES = [
  'LinkedIn',
  'Indeed',
  'Company Website',
  'Referral',
  'Job Fair',
  'University',
  'Social Media',
  'Other',
];

export const KPI_TOOLTIPS = {
  total: 'Total number of candidates in the system (active records only)',
  ongoing: 'Candidates currently in the pipeline — not Hired or Rejected',
  hired: 'Total candidates who have been hired',
  rejected: 'Total candidates who have been rejected',
  thisMonth: 'New applications received in the current calendar month',
  avgScore: 'Average assessment score across all completed tests',
  assessmentPassRate: 'Share of completed assessments whose score meets the per-type pass line (Settings → Classification)',
  overallPassFour: 'Among candidates who completed all four timed assessment types: pass rate using the org “overall pass” rule (weighted mean or all must pass)',
  qualificationRate: 'Percentage of candidates who reached Qualified stage or beyond',
};

export const PERMISSION_GROUPS = ['candidates', 'jobs', 'assessments', 'emails', 'settings'];
export const PERMISSION_ACTIONS = ['view', 'create', 'edit', 'delete'];
